import { Component, OnInit } from '@angular/core';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';

@Component({
  selector: 'app-kisok-login-register',
  templateUrl: './kisok-login-register.component.html',
  styleUrls: ['./kisok-login-register.component.css']
})
export class KisokLoginRegisterComponent implements OnInit {

  constructor(
    private kioskStateService: KioskStateService,
  ) {
  }


  ngOnInit() {
  }

  loggedIn() {
    this.kioskStateService.update(KioskStateEnum.CreateOrder);
  }

  register() {
    this.kioskStateService.update(
      KioskStateEnum.RegisterWithOrder
    );
  }

  registerAsGuest() {
    this.kioskStateService.update(
      KioskStateEnum.RegisterWithOrder
    );
  }
}
